import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { PAGE_LAYOUT_CONTAINER_SELECTOR } from '../../common/constants';
import { useSkipLinks } from '../../controllers';
import { skipLinkStyles } from './styles';

var assignIndex = function assignIndex(num, arr) {
  if (!arr.includes(num)) {
    return num;
  }

  return assignIndex(num + 1, arr);
};

export var SkipLinkWrapper = function SkipLinkWrapper(_ref) {
  var skipLinksLabel = _ref.skipLinksLabel;

  var _useSkipLinks = useSkipLinks(),
      skipLinksData = _useSkipLinks.skipLinksData;

  if (skipLinksData.length === 0) {
    return null;
  }

  var sortSkipLinks = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function (link) {
      return Number.isInteger(link.listIndex);
    });

    if (customLinks.length === 0) {
      return arr;
    }

    var usedIndexes = customLinks.map(function (a) {
      return a.listIndex;
    });
    var regularLinksWithIdx = arr.filter(function (link) {
      return link.listIndex === undefined;
    }).map(function (link, idx, currArr) {
      var listIndex = assignIndex(idx, usedIndexes);
      usedIndexes.push(listIndex);
      return _objectSpread(_objectSpread({}, link), {}, {
        listIndex: listIndex
      });
    });
    return [].concat(_toConsumableArray(customLinks), _toConsumableArray(regularLinksWithIdx)).sort(function (a, b) {
      return a.listIndex - b.listIndex;
    });
  };

  var escapeHandler = function escapeHandler(event) {
    if (event.keyCode === 27) {
      var container = document.querySelector("[".concat(PAGE_LAYOUT_CONTAINER_SELECTOR, "=\"true\"]"));

      if (container !== null) {
        container.focus();
      }
    }
  };

  var attachEscHandler = function attachEscHandler() {
    return window.addEventListener('keydown', escapeHandler, false);
  };

  var removeEscHandler = function removeEscHandler() {
    return window.removeEventListener('keydown', escapeHandler, false);
  };

  return jsx("div", {
    onFocus: attachEscHandler,
    onBlur: removeEscHandler,
    css: skipLinkStyles,
    "data-skip-link-wrapper": true
  }, jsx("h5", null, skipLinksLabel), jsx("ol", null, sortSkipLinks(skipLinksData).map(function (_ref2) {
    var id = _ref2.id,
        skipLinkTitle = _ref2.skipLinkTitle;
    return jsx(SkipLink, {
      key: id,
      href: "#".concat(id),
      isFocusable: true,
      title: "".concat(skipLinksLabel, " ").concat(skipLinkTitle)
    }, skipLinkTitle);
  })));
};

var handleBlur = function handleBlur(event) {
  // @ts-ignore
  event.target.removeAttribute('tabindex'); // @ts-ignore

  event.target.removeEventListener('blur', handleBlur);
};

var focusTargetRef = function focusTargetRef(href) {
  return function (event) {
    event.preventDefault();
    var targetRef = document.querySelector(href); // @ts-ignore

    var key = event.which || event.keycode; // if it is a keypress and the key is not
    // space or enter, just ignore it.

    if (key && key !== 13 && key !== 32) {
      return;
    }

    if (targetRef) {
      targetRef.setAttribute('tabindex', '-1'); // @ts-ignore

      targetRef.addEventListener('blur', handleBlur); // @ts-ignore

      targetRef.focus();
      document.activeElement && document.activeElement.scrollIntoView({
        behavior: 'smooth'
      });
      window.scrollTo(0, 0);
    }

    return false;
  };
};

export var SkipLink = function SkipLink(_ref3) {
  var href = _ref3.href,
      children = _ref3.children,
      isFocusable = _ref3.isFocusable,
      title = _ref3.title;
  return jsx("li", null, jsx("a", {
    tabIndex: isFocusable ? 0 : -1,
    href: href,
    onClick: focusTargetRef(href),
    title: title
  }, children));
};